import '@linktivity/link-styles';
import '@kurotetsu/share/styles/index.css';
import '@kurotetsu/public/styles/index.css';
import '@kurotetsu/public/i18n';
import '@kurotetsu/public/apis/fetchUtils';
import App from '@kurotetsu/public/App';
import React from 'react';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
